// extracted by mini-css-extract-plugin
module.exports =  {"list":"_02712f2b3b--list--EO8rV","item-wrapper":"_02712f2b3b--item-wrapper--_btvn","indented":"_02712f2b3b--indented--WhqXG","item":"_02712f2b3b--item--SZJyk"};